
app.controller(
  'notCtrl',
  function (
    $rootScope, $scope, services, ServiceQcm, toastr, ngTableParams,
    $filter, $location, FileUploader) {
    var _DEBUG = 0;
    $scope.url_ = $rootScope.url_;


    $scope.choixPAGE = 3;

    $scope.init = function () {
      $rootScope.menuSelectionne = 6;
      if (typeof ($rootScope.qcmSelectionne) == 'undefined') {
        $scope.choixQCM = -1;
        $rootScope.menuSelectionne = 1;
        $location.path('/0lst');
      }
      if (typeof ($rootScope.qcmSelectionne.id) == 'undefined') {
        $scope.choixQCM = -1;
        $rootScope.menuSelectionne = 1;
        $location.path('/0lst');
      }

      $scope.loader = 1;
      $scope.choixQCM = $rootScope.qcmSelectionne.id;
      $scope.nbEtudiant = $rootScope.qcmSelectionne.nbEtudiant;

      if ($rootScope.qcmSelectionne.listeCopie.length == 0) {
        toastr.error('___Il reste des erreurs : Attention !___');
      }

      var liste_des_notes = new Array;

      // new
      // ServiceQcm.initListeEtudiant($rootScope.qcmSelectionne).then(function(data1)
      // {
      new ServiceQcm.chargement($rootScope.qcmSelectionne)
        .then(function (data) {
          $scope.qcmSelectionne = data;
          $rootScope.qcmSelectionne = data;

          new ServiceQcm.calculNotes($rootScope.qcmSelectionne)
            .then(function (data2) {
              if ($rootScope.qcmSelectionne.listeEtudiant.length >
                0) {  // il y a des étudiants

                for (var i = 0;
                  i < $rootScope.qcmSelectionne.listeEtudiant.length;
                  i++) {
                  var tab = {
                    'id': $rootScope.qcmSelectionne.listeEtudiant[i]
                      .idetudiant,
                    'm':
                      $rootScope.qcmSelectionne.listeEtudiant[i].moyenne
                  };
                  liste_des_notes.push(tab);
                }
              }
              // refaire le calcul des moyennes (en changeant la
              // question)**************************************

              $scope.listeEtudiant =
                $rootScope.qcmSelectionne.listeEtudiant;
              $scope.a = liste_des_notes;

              services
                .updateNotes(
                  $rootScope.qcmSelectionne.id, liste_des_notes)
                .then(function (
                  data) {  // appel fct "solution(idqcm) dans app.js
                  /**/
                  $scope.listeEtudiant =
                    $rootScope.qcmSelectionne.listeEtudiant;
                  $scope.data2 = $scope.listeEtudiant;
                  var nb_max = Math.max(
                    $rootScope.qcmSelectionne.listeEtudiant.length,
                    100);

                  $scope.tableDesEtudiants = new ngTableParams(
                    {
                      page: 1,    // show first page
                      count: 10,  // count per page
                      sorting: { id: 'Numero' }
                    },
                    {
                      total: $scope.listeEtudiant
                        .length,  // length of data
                      counts: [10, 25, nb_max],
                      getData: function ($defer, params) {
                        //$scope.var  = params//pour affichage
                        // uniquement (à supprimer apres)  !!
                        $scope.data2 = params.filter() ?
                          $filter('filter')(
                            $scope.listeEtudiant,
                            params.filter()) :
                          $scope.listeEtudiant;
                        $scope.data2 = params.sorting() ?
                          $filter('orderBy')(
                            $scope.data2, params.orderBy()) :
                          $scope.data2;
                        $scope.data2 = $scope.data2.slice(
                          (params.page() - 1) * params.count(),
                          params.page() * params.count());

                        $defer.resolve($scope.data2);
                        params.total($scope.data2.length);
                      }
                    });
                  /**/
                  $scope.doute = 0;
                  for (var i = 0;
                    i < $rootScope.qcmSelectionne.listeCopie.length;
                    i++) {
                    if ($rootScope.qcmSelectionne.listeCopie[i].doute >
                      0) {
                      $scope.doute++;
                    }
                  }
                  $scope.loader = 0;
                });  // update notes
            });        // calculNotes
        });              // initListeEtudiant
    };                     // init
    /******************************************************************************************************/
    $scope.cancel = function () {  // revenir à la liste des qcm
      $location.path('/0lst');
    };

    /************************************************************************************************/

    var reussite = 1;
    var uploader = $scope.uploader = new FileUploader({
      url: '/envoiSujetpourArchive/',
      formData: [{ 'id': $rootScope.qcmSelectionne.id }]
    });

    // FILTERS

    uploader.filters.push({
      name: 'customFilter',
      fn: function (item /*{File|FileLikeObject}*/, options) {
        return this.queue.length < 10;
      }
    });

    // CALLBACKS

    uploader.onWhenAddingFileFailed = function (
      item /*{File|FileLikeObject}*/, filter, options) {
      if (_DEBUG)
        console.info('onWhenAddingFileFailed', item, filter, options);
    };
    uploader.onAfterAddingFile = function (fileItem) {
      if (_DEBUG) console.info('onAfterAddingFile', fileItem);
    };
    uploader.onAfterAddingAll = function (addedFileItems) {
      if (_DEBUG) console.info('onAfterAddingAll', addedFileItems);
    };
    uploader.onBeforeUploadItem = function (item) {
      if (_DEBUG) console.info('onBeforeUploadItem', item);
      // le nom 'token' est celui définit dans le programme 'satellizer.js'
      // dans node_modules
      item.headers = {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      };
      $scope.chargementEnCours = 1
    };
    uploader.onProgressItem = function (fileItem, progress) {
      if (_DEBUG) console.info('onProgressItem', fileItem, progress);
    };
    uploader.onProgressAll = function (progress) {
      if (_DEBUG) console.info('onProgressAll', progress);
    };
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      if (_DEBUG)
        console.info('onSuccessItem', fileItem, response, status, headers);
    };
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      if (_DEBUG)
        console.info('onErrorItem', fileItem, response, status, headers);
    };
    uploader.onCancelItem = function (fileItem, response, status, headers) {
      if (_DEBUG)
        console.info('onCancelItem', fileItem, response, status, headers);
    };
    uploader.onCompleteItem = function (fileItem, response, status, headers) {
      if (response.stdout == 'pb: pas un fichier de solution') {
        toastr.error('___Ce n\'est pas un fichier de solution compatible___');
        reussite = 0;
      } else
        reussite = 1;
    };
    uploader.onComplete = function (response, status, headers) { };
    uploader.onCompleteAll = function () {
      if (_DEBUG) console.info('onCompleteAll');

      // récupérer le fichier
      services.archive($rootScope.qcmSelectionne.id).then(function (data) {
        if (reussite == 1) {
          toastr.success('___Sujet envoyé___');
          document.getElementById('myModal').click();
        }
      });
    };

    /******************************************************************************************************/

    $scope.envoyerFichier = function () {
      if ($scope.afficheFichier == 0)
        $scope.afficheFichier = 1;
      else
        $scope.afficheFichier = 0;
    };

    /******************************************************************************************************/
  });
